<template>
  <div class="brandIntro">
    <div class="top-box">
      <div class="bg-box" :style="{ backgroundImage: 'url(' + brandLogo + ')' }"></div>
    </div>

    <div class="desc">
      <div class="avatar">
        <img class="img" :src="brandLogo">
      </div>

      <h2 class="desc-title">{{brandName}}</h2>

      <div class="content" :class="{ellipsis: !isExpand}">
        {{brandIntro}}
      </div>

      <div class="viewAll" @click="isExpand = !isExpand" v-if="brandIntro">
        <span style="margin-right: 6px;">查看全部</span>
        <i class="el-icon-arrow-up" v-if="isExpand"></i>
        <i class="el-icon-arrow-down" v-else></i>
      </div>
    </div>

    <div class="experience">
      <h2 class="experience-title">品牌经历</h2>

      <div class="list">
        <div class="item" v-if="brandVideo">
          <img class="play_icon" src="@/assets/play.png" @click="videoShow = true">
          <video style="object-fit: fill" :src="brandVideo" :poster="brandVideoCoverPciture"></video>
        </div>
        <div class="item"
          v-for="(item, index) in brandImageUrlList"
          :key="index"
        >
          <img :src="item" @click="previewImage(index)">
        </div>
      </div>
    </div>

    <div class="process-box">
      <div class="process-item"
        v-for="(item, index) in brandHistoryList"
        :key="index"
      >
        <div class="date">
          <div class="date-box">
            <span class="num">{{item.startDate | parseTime('{y}.{m}')}}</span>
            <span class="line"></span>
            <span class="num">{{item.endTime | parseTime('{y}.{m}')}}</span>
          </div>
        </div>
        <div class="process-line">
          <div class="yuan">
            <div class="dian"></div>
          </div>
          <div class="line"></div>
        </div>
        <div class="text">
          {{item.content}}
        </div>
      </div>
    </div>

    <van-popup :lazy-render	="false" style="width: 100%;" v-model="videoShow">
      <video style="width: 100%;" id="video" ref="video" :src="brandVideo" :poster="brandVideoCoverPciture" controls></video>
    </van-popup>
  </div>
</template>

<script>
import { Popup, ImagePreview } from 'vant'
import { grandInfo } from '@/api/brandIntro'

export default {
  components: {
    vanPopup: Popup
  },
  data() {
    return {
      isExpand: false,
      videoShow: false,
      brandLogo: '',
      brandName: '',
      brandIntro: '',
      brandVideo: '',
      brandVideoCoverPciture: '',
      brandImageUrlList: [],
      brandHistoryList: []
    }
  },
  watch: {
    videoShow(value) {
      if (value) {
        this.$nextTick(() => {
          // this.$refs.video.load()
          this.$refs.video.play()
        })
      } else {
        this.$refs.video.pause()
      }
    }
  },
  mounted() {
    document.title = '品牌介绍'
    this.id = this.$route.query.id

    this.getGrandInfo()
  },
  methods: {
    getGrandInfo() {
      grandInfo({
        Id: this.id
      }).then(res => {
        if (res.code === 200) {
          let data = res.data
          this.brandLogo = data.brandLogo
          this.brandName = data.brandName
          this.brandIntro = data.brandIntro
          this.brandVideo = data.brandVideo
          if(this.brandVideo){
            this.brandVideoCoverPciture = this.brandVideo +'?x-oss-process=video/snapshot,t_10000,m_fast'
          }
          this.brandImageUrlList = data.brandImageUrlList
          this.brandHistoryList = data.brandHistoryList
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    previewImage(index) {
      ImagePreview({
        images: this.brandImageUrlList,
        startPosition: index
      })
    }
  }
}
</script>

<style lang="scss">
.brandIntro {
  .vm-player {
    min-height: 0;
  }
  .el-image {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

<style lang="scss" scoped>
.brandIntro {
  h2 {
    margin: 0;
  }
  .top-box {
    position: relative;
    width: 100%;
    height: 49vw;
    .title {
      position: absolute;
      top: 15px;
      left: 50%;
      z-index: 1;
      transform: translateX(-50%);
      font-size: 16px;
      font-weight: bold;
      color: #1F1F1F;
    }
    .bg-box {
      width: 100%;
      height: 100%;
      filter: blur(2px);
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: center;
    }
  }

  .desc {
    position: relative;
    padding-top: 15.66vw;
    padding-left: 4.08vw;
    padding-right: 4.08vw;
    padding-bottom: 8.4vw;
    box-sizing: border-box;
    .avatar {
      position: absolute;
      top: -12.35vw;
      left: 50%;
      z-index: 1;
      transform: translateX(-50%);
      width: 21.65vw;
      height: 21.65vw;
      border-radius: 3px;
      overflow: hidden;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.15);
      img {
        width: 100%;
        height: 100%;
      }
      .img {
        width: 100%;
        height: 100%;
      }
    }

    .desc-title {
      margin-bottom: 15px;
      font-size: 16px;
      font-weight: bold;
      color: #1F1F1F;
    }

    .content {
      margin-bottom: 16px;
      font-size: 12px;
      font-weight: 500;
      color: #585858;
      line-height: 20px;
      &.ellipsis {
        overflow: hidden; /*文本超出隐藏*/
        display:-webkit-box; /*盒子模型微弹性伸缩模型*/
        -webkit-box-orient: vertical;/*伸缩盒子的子元素垂直排列*/
        -webkit-line-clamp: 3; /*文本显示3行*/
      }
    }

    .viewAll {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 500;
      color: #000000;
      opacity: 0.8;
    }
  }

  .experience {
    padding-left: 4.08vw;
    padding-right: 4.08vw;
    padding-bottom: 6.75vw;
    box-sizing: border-box;
    .experience-title {
      margin-bottom: 15px;
      font-size: 16px;
      font-weight: bold;
      color: #1F1F1F;
    }

    .list {
      display: flex;
      width: 100%;
      height: 24.58vw;
      padding-left: 4.08vw;
      box-sizing: border-box;
      overflow-x: auto;
      overflow-y: hidden;
      .item {
        position: relative;
        margin-right: 4.08vw;
        flex: 0 0 36.18vw;
        height: 24.58vw;
        border-radius: 4px;
        overflow: hidden;
        &:last-child {
          margin-right: 0;
        }
        .play_icon {
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 1;
          transform: translateX(-50%) translateY(-50%);
          width: 10vw;
          height: 10vw;
        }
        video {
          width: 100%;
          min-height: 100%;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .process-box {
    width: 100%;
    padding-left: 4.96vw;
    padding-bottom: 30px;
    box-sizing: border-box;
    .process-item {
      display: flex;
      &:last-child {
        .text {
          margin-bottom: 0;
        }
      }
      .date {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-right: 5.47vw;
        .date-box {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .num {
          font-size: 14px;
          font-weight: 500;
          color: #8D8D8D;
        }
        .line {
          width: 1px;
          height: 10px;
          background-color: #8D8D8D;
        }
      }
      .process-line {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 20px;
        .yuan {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 10px;
          height: 10px;
          border: 1px solid #FF6633;
          border-radius: 50%;
          .dian {
            width: 3px;
            height: 3px;
            background: #FF6633;
            border-radius: 50%;
          }
        }
        .line {
          width: 1px;
          flex: 1;
          background-color: rgba(0, 0, 0, .08);
        }
      }
      .text {
        flex: 1;
        margin-bottom: 9.18vw;
        padding: 10px;
        font-size: 15px;
        font-weight: 500;
        color: #1F1F1F;
        line-height: 24px;
        background: #F2F2F2;
        border-radius: 6px 0px 0px 6px;
      }
    }
  }
}
</style>